import React from 'react'
import NewCookies from './NewCookies'
import CommonBanner from '../Banner/CommonBanner'
import BannerImg1 from "../images/corporate-strategy.png"

export default function NewBusiness(props) {
    return (
        <div>
           
            <div>
                <CommonBanner smalltitle={"AI-Powered"} setHandleReqPop={props.setHandleReqPop} title={"New Business Development"} desc1={"Ideapoke is where teams can collaborate to develop new businesses and get market ready"} dImage={BannerImg1}></CommonBanner>
                <NewCookies title={"New Business Development"}></NewCookies>
    
            </div>
        </div>
    )
}
